import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setNarrativeState } from '../store/narrative.actions'

export function* getNarrative(pcrDoc: IPcr) {
  const narrative = pcrDoc.patient?.narrative
  if (narrative && Object.keys(narrative).length !== 0) {
    yield put(setNarrativeState(narrative))
  }
}
